import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function FooterManagement() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-3">
            {/* BRANDING SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>Branding & Hero Footer</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label label="Banner Image" className="mb-2" />
                    <ImageUploader
                      imgStyle={{ width: "100%", height: "200px" }}
                      imageUrl={values.banner_image}
                      onChange={(res) => setFieldValue("banner_image", res?.data?.file_url)}
                    />
                  </div>
                  <div>
                    <Label label="Logo" className="mb-2" />
                    <ImageUploader
                      imgStyle={{ width: "150px", height: "100px" }}
                      imageUrl={values.logo}
                      onChange={(res) => setFieldValue("logo", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div>
                    <Label label="Title (White Part)" className="mb-1" />
                    <FormikInput name="title.white" placeholder="White Part" />
                  </div>
                  <div>
                    <Label label="Title (Orange Part)" className="mb-1" />
                    <FormikInput name="title.orange" placeholder="Orange Part" />
                  </div>
                </div>

                <div className="mt-4">
                  <Label label="Description" className="mb-1" />
                  <FormikTextarea name="description" placeholder="Description" />
                </div>

                <div className="mt-4">
                  <Label label="Hero Buttons" className="mb-2 font-semibold" />
                  <FieldArray name="buttons">
                    {(arrayHelpers) => (
                      <table className="w-full border">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="p-2 border">Label</th>
                            <th className="p-2 border">Link (Href)</th>
                            <th className="p-2 border">Variant</th>
                            <th className="p-2 border">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.buttons.map((btn, index) => (
                            <tr key={index}>
                              <td className="p-2 border">
                                <FormikInput name={`buttons.${index}.label`} />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`buttons.${index}.href`} />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`buttons.${index}.variant`} placeholder="filled/outline" />
                              </td>
                              <td className="p-2 border text-center">
                                <button type="button" onClick={() => arrayHelpers.remove(index)}>
                                  <FontAwesomeIcon icon={faTrash} className="text-red-500" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="4" className="p-2">
                              <Button type="button" onClick={() => arrayHelpers.push({ label: "", href: "", variant: "filled" })}>
                                + Add Button
                              </Button>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    )}
                  </FieldArray>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* LINKS SECTIONS */}
            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>Footer Links (Explore, Social, Contact)</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* Explore Links */}
                  <div>
                    <Label label="Explore Links" className="mb-2 font-bold" />
                    <FieldArray name="explore_links">
                      {(arrayHelpers) => (
                        <div className="space-y-2">
                          {values.explore_links.map((_, index) => (
                            <div key={index} className="flex gap-2 items-start border p-2 rounded">
                              <div className="flex-1">
                                <FormikInput name={`explore_links.${index}.label`} placeholder="Label" className="mb-1" />
                                <FormikInput name={`explore_links.${index}.href`} placeholder="URL" />
                              </div>
                              <button type="button" onClick={() => arrayHelpers.remove(index)}>
                                <FontAwesomeIcon icon={faTrash} className="text-red-500 mt-2" />
                              </button>
                            </div>
                          ))}
                          <Button type="button" variant="outline" className="w-full" onClick={() => arrayHelpers.push({ label: "", href: "" })}>
                            + Add Link
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  {/* Social Links */}
                  <div>
                    <Label label="Social Links" className="mb-2 font-bold" />
                    <FieldArray name="social_links">
                      {(arrayHelpers) => (
                        <div className="space-y-2">
                          {values.social_links.map((_, index) => (
                            <div key={index} className="flex gap-2 items-start border p-2 rounded">
                              <div className="flex-1">
                                <FormikInput name={`social_links.${index}.label`} placeholder="Label" className="mb-1" />
                                <FormikInput name={`social_links.${index}.href`} placeholder="URL" />
                              </div>
                              <button type="button" onClick={() => arrayHelpers.remove(index)}>
                                <FontAwesomeIcon icon={faTrash} className="text-red-500 mt-2" />
                              </button>
                            </div>
                          ))}
                          <Button type="button" variant="outline" className="w-full" onClick={() => arrayHelpers.push({ label: "", href: "" })}>
                            + Add Link
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  {/* Contact Links */}
                  <div>
                    <Label label="Contact Links" className="mb-2 font-bold" />
                    <FieldArray name="contact_links">
                      {(arrayHelpers) => (
                        <div className="space-y-2">
                          {values.contact_links.map((_, index) => (
                            <div key={index} className="flex gap-2 items-start border p-2 rounded">
                              <div className="flex-1">
                                <FormikInput name={`contact_links.${index}.label`} placeholder="Label (e.g. Email: ...)" className="mb-1" />
                                <FormikInput name={`contact_links.${index}.href`} placeholder="mailto:... or tel:..." />
                              </div>
                              <button type="button" onClick={() => arrayHelpers.remove(index)}>
                                <FontAwesomeIcon icon={faTrash} className="text-red-500 mt-2" />
                              </button>
                            </div>
                          ))}
                          <Button type="button" variant="outline" className="w-full" onClick={() => arrayHelpers.push({ label: "", href: "" })}>
                            + Add Link
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* RERA & BOTTOM SECTION */}
            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>RERA Details & Bottom Links</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-4">
                    <div>
                      <Label label="RERA Registration No." className="mb-1" />
                      <FormikInput name="rera_details.reg_no" />
                    </div>
                    <div>
                      <Label label="Dated" className="mb-1" />
                      <FormikInput name="rera_details.date" />
                    </div>
                    <div>
                      <Label label="Valid Upto" className="mb-1" />
                      <FormikInput name="rera_details.valid_upto" />
                    </div>
                  </div>
                  <div>
                    <Label label="RERA QR Code" className="mb-2" />
                    <ImageUploader
                      imgStyle={{ width: "100px", height: "100px" }}
                      imageUrl={values.rera_details.qr_code}
                      onChange={(res) => setFieldValue("rera_details.qr_code", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="mt-6 border-t pt-4">
                  <Label label="Bottom Policy Links" className="mb-2 font-semibold" />
                  <FieldArray name="bottom_links">
                    {(arrayHelpers) => (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {values.bottom_links.map((_, index) => (
                          <div key={index} className="flex gap-2 items-start border p-2 rounded">
                            <div className="flex-1">
                              <FormikInput name={`bottom_links.${index}.label`} placeholder="Label" className="mb-1" />
                              <FormikInput name={`bottom_links.${index}.href`} placeholder="URL" />
                            </div>
                            <button type="button" onClick={() => arrayHelpers.remove(index)}>
                              <FontAwesomeIcon icon={faTrash} className="text-red-500 mt-2" />
                            </button>
                          </div>
                        ))}
                        <Button type="button" variant="outline" onClick={() => arrayHelpers.push({ label: "", href: "" })}>
                          + Add Bottom Link
                        </Button>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="mt-4">
                  <Label label="Copyright Text" className="mb-1" />
                  <FormikInput name="copyright_text" placeholder="© Copyright 2026..." />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button
              type="submit"
              label="SAVE CHANGES"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
